import {useViewerStore} from "../../../store/store";
import {Input} from "antd";
import {useState} from "react";

type NotesTextAreaProps = {
    value: string,
    disabled: boolean,
    onChange: any
}

const NotesTextArea = (props: NotesTextAreaProps) => {
    const {value, disabled, onChange} = props;
    const [autoSize, setAutoSize] = useState(false);

    return (
        <Input.TextArea
            rows={1}
            className="small_input_flex small_text_area"
            value={value}
            onChange={onChange}
            disabled={disabled}
            autoSize={autoSize}
            style={{resize: "none"}}
            onFocus={() => {
                setAutoSize(true);
                useViewerStore.setState({isModalOpenInInterface: true});
            }}
            onBlur={() => {
                setAutoSize(false);
                useViewerStore.setState({isModalOpenInInterface: false});
            }}
        />
    );
};

export default NotesTextArea;